/** File download + dataset serialization helpers (CSV / JSON / chaos). */
import { csvEscape } from './csv';
import type { ChaosRow, ParseResult } from './types';

export function baseFileName(fileName: string, fallback = 'dataset'): string {
  const base = (fileName.split(/[\\/]/).pop() ?? fileName).trim();
  const stem = base.replace(/\.[^.]+$/, '').trim();
  return stem === '' ? fallback : stem;
}

export function downloadFile(name: string, content: string, mime: string): void {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function toJson(value: unknown): string {
  return `${JSON.stringify(value, null, 2)}\n`;
}

function cellText(value: string | null): string {
  return value === null ? '' : value;
}

export function chaosToCsv(headers: string[], rows: ChaosRow[]): string {
  const lines = [headers.map((h) => csvEscape(h)).join(',')];
  for (const row of rows) {
    lines.push(headers.map((h) => csvEscape(row[h] ?? null)).join(','));
  }
  return lines.join('\n');
}

export function cleanedToCsv(result: ParseResult): string {
  const lines = [result.headers.map((h) => csvEscape(h)).join(',')];
  for (const row of result.rows) lines.push(row.map((v) => csvEscape(v)).join(','));
  return lines.join('\n');
}

export function cleanedToJson(result: ParseResult): string {
  const records = result.rows.map((row) => {
    const rec: Record<string, string | null> = {};
    result.headers.forEach((h, i) => {
      rec[h] = row[i] ?? null;
    });
    return rec;
  });
  return toJson(records);
}

export { cellText };
